import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EulaService } from '../../services/eula/eula.service';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { BootController } from '../../../boot-control';
import { NotifierService } from 'angular-notifier';
import { OrganisationService } from '../../services/settings/organisation.service';

@Component({
  selector: 'app-eula-dialog',
  templateUrl: './eula-dialog.component.html',
  styleUrls: ['./eula-dialog.component.scss']
})

export class EulaDialogComponent implements OnInit {
  eulaContent: any = '';
  agreeBtnDisabled = true;
  private readonly notifier: NotifierService;

  constructor(public dialogRef: MatDialogRef<EulaDialogComponent>,
    private eulaService: EulaService,
    private token: TokenStorageService,
    private ngZone: NgZone,
    private login: LoginService, private router: Router,
    private notifierService: NotifierService,
    private orgService: OrganisationService,
    @Inject(MAT_DIALOG_DATA) private data) {
      this.notifier = notifierService;
  }

  ngOnInit() {
    this.loadEULAContent();
  }

  onScroll(event) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight)
      this.agreeBtnDisabled = false;
  }

  loadEULAContent() {
    this.eulaService.downloadEulaContent().subscribe((response: any) => {
      if (response) {
        this.eulaContent = response;
        setTimeout(() => {
          if (document.getElementById('eula-content').scrollHeight < 200) {
            this.agreeBtnDisabled = false;
          }
        }, 1000);
      }
    });
  }

  onAgree() {
    this.notifier.notify("info", "Processing...", "0");
    const payload = {
      Authorization: localStorage.getItem('AuthorizationD'),
      JSESSIONID: localStorage.getItem('JSESSIONID')
    }
    this.eulaService.acceptEula(payload).subscribe((response) => {
      this.notifier.hide("0");
      this.dialogRef.close();
      console.log(this.data.userRsp)
      const data = this.data.userRsp

      window.sessionStorage.setItem("setPassword", data.changePassword);
      localStorage.setItem("loggedInUser", JSON.stringify(data));
      localStorage.setItem("setPassword", data.changePassword);

      let orgId = JSON.parse(localStorage.getItem("loggedInUser")).orgId;
      this.orgService.getOrgBasicConfigData(orgId).then((response) => {
        localStorage.setItem("orgConfig", JSON.stringify(response[0]));
      });
      this.login.navigateToHomePage();
     });
  }

  onDisagree() {
    this.dialogRef.close();
    this.login.logout().then(data => {
      localStorage.removeItem('AuthorizationD');
      localStorage.removeItem('JSESSIONID');
      localStorage.removeItem('token');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('selectedTile');
      localStorage.removeItem('widgets');
      localStorage.removeItem('loggedInUser');
      localStorage.removeItem('userId');
      localStorage.removeItem('setPassword');
      localStorage.removeItem('orgConfig');
      this.token.signOut();
      // Triggers the reboot in main.ts
      this.ngZone.runOutsideAngular(() => BootController.getbootControl().restart());
      this.router.navigate(['/login']);
    },
    error => {
      console.error("error on disagreeing eula");
    });
  }
}
